import {MODAL_WIDTH_SM} from '../../../../../styles/constants';
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import {getFileMappingWizardCalcColumnValueListColValues, hideFileMappingWizardCalculatedColumnValueList} from './actions';
import EnhancedModal from '../../../../../components/enhanced-modal';
import {Button} from "antd";
import {getFilterObjFromViewerObj} from "../../../../../utils/filter";
import InfiniteScrollDataTable from "../../../../../components/infinite-scroll-data-table";

const mapStateToProps = state => ({
  colName: state.scenes.dataManager.fileMapping.components.wizard.components.calcColumnValueList.colName,
  colValues: state.scenes.dataManager.fileMapping.components.wizard.components.calcColumnValueList.colValues,
  hasAlias: state.scenes.dataManager.fileMapping.components.wizard.components.calcColumnValueList.hasAlias,
  mergedHeaders: state.scenes.dataManager.fileMapping.components.wizard.shared.mergedHeaders,
  tempTableName: state.scenes.dataManager.fileMapping.components.wizard.shared.tempTableName,
});

const mapDispatchToProps = dispatch => ({
  onHide: () => dispatch(hideFileMappingWizardCalculatedColumnValueList()),
  fetchColValues: (colName, pageNum, pageSize, filterTable, sortCols, sortByDesc, tableName, hasAlias) =>
    dispatch(getFileMappingWizardCalcColumnValueListColValues(colName, pageNum, pageSize, filterTable, sortCols, sortByDesc, tableName, hasAlias))
});

const FileMappingWizardCalcColumnValueList = ({
                                               t,
                                               colName,
                                               colValues,
                                               mergedHeaders,
                                               onHide,
                                               fetchColValues,
                                               tempTableName,
                                               hasAlias
                                             }) =>
  <EnhancedModal
    visible={colName !== null}
    onCancel={onHide}
    title={t('scenes.dataManager.fileMapping.wizard.colValueList.title')}
    width={MODAL_WIDTH_SM}
    footer={<Button onClick={onHide}>{t('commons.buttons.close.title')}</Button>}
  >
    {mergedHeaders !== null && (
      <InfiniteScrollDataTable
        data={colValues && colValues.Data}
        rowTotal={colValues && colValues.Count}
        cols={colValues && colValues.Columns}
        onChange={
          ({pageNum, pageSize, searchText, filters, sortCol, sortByDesc}) => fetchColValues(
            colName,
            pageNum,
            pageSize,
            getFilterObjFromViewerObj(
              colValues && colValues.Columns,
              searchText,
              filters
            ),
            sortCol ? [sortCol] : null,
            sortByDesc,
            tempTableName,
            hasAlias
          )
        }
      />
    )}
  </EnhancedModal>;

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(FileMappingWizardCalcColumnValueList);
